import __ from "web/Layout/Translations";

import useLangFromParams from "web/hooks/useLangFromParams/useLangFromParams";

import { linksArticles } from "../../helpCenterArticle.mock";
import LinksList from "./LinksList";
import classes from "./aside.scss";

const HCArticleDesktopAside = ({ categories, prefix }) => {
  const { isParamLangEn } = useLangFromParams();
  return (
    <aside className={classes.root}>
      <div className={classes.sticky}>
        <div className={classes.title}>
          {isParamLangEn ? "Also check" : __("Zobacz również")}
        </div>
        <LinksList
          links={linksArticles}
          categories={categories}
          prefix={prefix}
        />
      </div>
    </aside>
  );
};

export default HCArticleDesktopAside;
